import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { ReactNode, useId } from 'react';

interface Props {
    label: string | undefined;
    shouldWrap?: boolean;
    wrapCount?: number | string | undefined;
    expanded?: boolean;
    accordionExpanded?: (result: boolean | null) => void;
    backgroundColor?: string;
    children: ReactNode;
}

export default function ExpandableWrapper({
    label,
    children,
    shouldWrap,
    expanded,
    accordionExpanded,
    backgroundColor,
}: Props) {
    const handleChange = () => {
        accordionExpanded?.(true);
    };

    const accordionId = useId();
    const headerId = `${accordionId}-header`;
    const contentId = `${accordionId}-content`;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const AccordionStyles = {
        width: '100%',
        margin: '16px 0',
        border: `1px solid ${theme.palette.neutral.N_300}`,
        boxSizing: 'border-box',
    };

    const AccordionDetailsStyles = {
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        padding: isMobile ? '8px 8px 16px' : '8px 16px 16px',
    };

    const AccordionSummaryStyles = {
        backgroundColor: backgroundColor || 'transparent', // Optional: summary can also be styled
    };

    return shouldWrap ? (
        <Accordion sx={AccordionStyles} expanded={expanded} onChange={handleChange}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                id={headerId}
                aria-controls={contentId}
                sx={AccordionSummaryStyles}
            >
                <Typography variant={'labelLarge'} color="text.primary">
                    {label}
                </Typography>
            </AccordionSummary>
            <AccordionDetails id={contentId} aria-labelledby={headerId} sx={AccordionDetailsStyles}>
                {children}
            </AccordionDetails>
        </Accordion>
    ) : (
        children
    );
}
